import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { RestService } from '../../../../shared/services/rest.service';
import { ToastService } from '../../../../shared/services/toast.service';
import { UserRepository } from '../../../user/states/user.repository';
import {
  AnimalMedicalRecordCreatePayload,
  AnimalMedicalRecordModel
} from '../../models/medical/animal-medical-record.model';

/** Karteikarte: unveränderlich, das Backend kennt nur GET und POST. */
@Injectable({ providedIn: 'root' })
export class AnimalMedicalRecordRepository {
  constructor(
    private readonly _restService: RestService,
    private readonly _toast: ToastService,
    private readonly _translateService: TranslocoService,
    private readonly _userRepository: UserRepository
  ) {}

  getByAnimalId(animalId: number): Observable<AnimalMedicalRecordModel[]> {
    return this._restService
      .httpGet(`/animal_medical_records?pagination=false&animal.id=${animalId}`)
      .pipe(
        take(1),
        map(response => (Array.isArray(response) ? response : [])),
        catchError(() => {
          this._toast.showError(this._translateService.translate('animalMedical.toast.loadError'));
          return of([] as AnimalMedicalRecordModel[]);
        })
      );
  }

  create(payload: AnimalMedicalRecordCreatePayload, silent = false): Observable<AnimalMedicalRecordModel | null> {
    return this._userRepository.getActiveUser().pipe(
      take(1),
      switchMap(activeUser => {
        if (!activeUser?.id) throw new Error('Kein aktiver Benutzer');
        return this._restService.httpPost('/animal_medical_records', { ...payload, creator: { id: activeUser.id } }).pipe(take(1));
      }),
      map(response => {
        if (!response) throw new Error('Leere Antwort');
        return response as AnimalMedicalRecordModel;
      }),
      catchError(() => {
        if (!silent) {
          this._toast.showError(this._translateService.translate('animalMedical.toast.record.saveError'));
        }
        return of(null);
      })
    );
  }
}
